/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [公众号授权链接↗](https://yapi.fenxianglife.com/project/379/interface/api/43786) 的 **请求函数**
 *
 * @分类 [微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9961)
 * @请求头 `GET /wechat/open/authUrl`
 * @更新时间 `2023-09-13 10:35:16`
 */
export const feimaChatWechatOpenAuthUrl = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWechatOpenAuthUrlRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWechatOpenAuthUrlResponse, OT>
  >('/wechat/open/authUrl', 'GET', data, options);

/**
 * 接口 [js api 签名↗](https://yapi.fenxianglife.com/project/379/interface/api/52552) 的 **请求函数**
 *
 * @分类 [微信相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9961)
 * @请求头 `POST /wechat/mp/js/sign`
 * @更新时间 `2024-07-02 14:29:19`
 */
export const feimaChatWechatMpJsSign = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWechatMpJsSignRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWechatMpJsSignResponse, OT>>(
    '/wechat/mp/js/sign',
    'POST',
    data,
    options
  );

/* prettier-ignore-end */
